import PropTypes from 'prop-types';
import { PureComponent } from 'react';

import Image from 'Component/Image';
import Link from 'Component/Link';
import RestrictedContentOverlay from 'Component/RestrictedContentOverlay';
import TextPlaceholder from 'Component/TextPlaceholder';
import { PageCardPropsType } from 'Type/CMS.type';
import { MixType } from 'Type/Common.type';

import './PageCard.style';

/** @namespace PeggysagePwa/Component/PageCard/Component */
export class PageCardComponent extends PureComponent {
    static propTypes = {
        isMobile: PropTypes.bool.isRequired,
        page: PageCardPropsType.isRequired,
        linkLabel: PropTypes.string.isRequired,
        isListing: PropTypes.bool.isRequired,
        mix: MixType,
        allowedCustomerGroupIds: PropTypes.arrayOf(PropTypes.number).isRequired,
        isHorizontal: PropTypes.bool.isRequired,
        isLinkVisible: PropTypes.bool.isRequired
    };

    static defaultProps = {
        mix: {}
    };

    renderTag() {
        const { page: { tag_label } } = this.props;

        if (!tag_label) {
            return null;
        }

        return (
            <div block="PageCard" elem="Tag">
                { tag_label }
            </div>
        );
    }

    renderCategory() {
        const { isListing, page: { category = {} } } = this.props;

        if (!isListing || !category) {
            return null;
        }

        const { name } = category;

        return (
            <div block="PageCard" elem="Category">
                <TextPlaceholder content={ name } length="short" />
            </div>
        );
    }

    renderType() {
        const {
            page: { page_type },
            isMobile,
            isHorizontal
        } = this.props;

        const pageTypes = {
            tutorial: __('Tutos et conseils'),
            news: __('News')
        };
        const pageType = pageTypes[page_type] || null;

        if (!isMobile || !isHorizontal || !pageType) {
            return null;
        }

        return (
            <div block="PageCard" elem="Type">
                { pageType }
            </div>
        );
    }

    renderLink() {
        const {
            page: { title, content_video },
            linkLabel,
            isLinkVisible
        } = this.props;

        if (!isLinkVisible) {
            return null;
        }

        return (
            <div block="PageCard" elem="Link" mods={ { hasVideo: !!content_video } }>
                { !title && <TextPlaceholder length="short" /> }
                { title && <span>{ linkLabel }</span> }
            </div>
        );
    }

    render() {
        const {
            page: {
                content_image,
                identifier,
                title
            },
            mix,
            allowedCustomerGroupIds,
            isHorizontal
        } = this.props;

        return (
            <div block="PageCard" mods={ { horizontal: isHorizontal } } mix={ mix }>
                <Link
                  block="PageCard"
                  elem="WrapperLink"
                  to={ identifier }
                >
                    <div block="PageCard" elem="Visual">
                        <div block="PageCard" elem="VisualInner">
                            <Image
                              mix={ { block: 'PageCard', elem: 'Image' } }
                              src={ content_image }
                              isPlaceholder={ !content_image }
                              alt=""
                              ratio="custom"
                            />
                        </div>
                    </div>
                    <div block="PageCard" elem="Content">
                        { this.renderTag() }
                        { this.renderCategory() }
                        { this.renderType() }
                        <h3 block="PageCard" elem="Title">
                            <TextPlaceholder content={ title } length="short" />
                        </h3>
                        { this.renderLink() }
                    </div>
                </Link>
                { !title && <span block="PageCard" elem="LoaderPreventClick" /> }
                <RestrictedContentOverlay
                  allowedCustomerGroupIds={ allowedCustomerGroupIds }
                />
            </div>
        );
    }
}

export default PageCardComponent;
